

























































import { CardScrapAgent } from '@/shared/model/scrap-agent.model';

export default {
  props: {
    data: {
      type: Object as () => CardScrapAgent,
      required: true,
    },
  },
  data() {
    return {
      dataCard: this.data as CardScrapAgent,
    };
  },
  mounted() {},
  methods: {
    handleConnect() {
      this.$emit('handleConnect', this.dataCard.cardId);
    },
  },
};
